webpackJsonp([2],{

/***/ 3394:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(3335);
	
	var _helpers = __webpack_require__(3378);
	
	var _actions = __webpack_require__(3392);
	
	var _selectors = __webpack_require__(3395);
	
	var _Activity = __webpack_require__(3415);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    filters: (0, _selectors.getFilter)(state),
	    aggregateEventUpdateAvailable: state.events.aggregateEventUpdateAvailable
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    createAction: (0, _helpers.buildActionsCollection)({
	      fetchAggregateEvents: _actions.fetchAggregateEvents
	    }, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Activity2.default);

/***/ },

/***/ 3395:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAggregateEvents = exports.parseAutoImportEvents = exports.parseEvents = exports.getFilter = exports.getEvents = exports.getAggregateEvents = undefined;
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reselect = __webpack_require__(3396);
	
	var _isEmpty = __webpack_require__(3397);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _helpers = __webpack_require__(3414);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAggregateEvents = exports.getAggregateEvents = function getAggregateEvents(state) {
	  return state.events.aggregateEvents;
	};
	var getEvents = exports.getEvents = function getEvents(state) {
	  return state.events.events;
	};
	var getFilter = exports.getFilter = function getFilter(state) {
	  return state.events.filter;
	};
	
	var parseEvents = exports.parseEvents = (0, _reselect.createSelector)(function (object) {
	  return object.events;
	}, function (events) {
	  if ((0, _isEmpty2.default)(events)) return [];
	  return events.map(function (event) {
	    return (0, _extends3.default)({
	      id: event.id,
	      affectedEntity: (0, _helpers.generateEventEntityName)(event.affectedEntity)
	    }, (0, _helpers.generateEventStatus)(event.result));
	  });
	});
	
	var parseAutoImportEvents = exports.parseAutoImportEvents = (0, _reselect.createSelector)(function (object) {
	  return object.events;
	}, function (events) {
	  if ((0, _isEmpty2.default)(events)) return [];
	  return events.map(function (event) {
	    return {
	      id: event.id,
	      affectedEntity: (0, _helpers.generateEventEntityName)(event.affectedEntity),
	      resultDisplay: (0, _helpers.generateResultDisplay)(event.result)
	    };
	  });
	});
	
	var parseAggregateEvents = exports.parseAggregateEvents = (0, _reselect.createSelector)(getAggregateEvents, function (aggregateEvents) {
	  if ((0, _isEmpty2.default)(aggregateEvents)) return [];
	  return aggregateEvents.map(function (event) {
	    var ruleObj = void 0;
	    var rulesetObj = void 0;
	
	    if (event.actor) {
	      ruleObj = event.actor.find(function (actor) {
	        return actor.type === "Rule";
	      });
	      rulesetObj = event.actor.find(function (actor) {
	        return actor.type === "Rule Set";
	      });
	    }
	
	    return {
	      key: '' + event.transactionId + (Math.floor(Math.random() * 9000) + 100),
	      transactionId: event.transactionId,
	      origin: event.origin,
	      aggregateEvent: (0, _helpers.generateAggregateEventDisplayName)(event),
	      trigger: (0, _helpers.generateAggregateEventTriggerDisplayName)(event),
	      timestamp: (0, _helpers.generateAggregateEventDisplayTime)(event.timestamp),
	      arReportUrl: (0, _helpers.getARLinkForEvent)(event.sampleResult),
	      ruleId: ruleObj ? ruleObj.id : null,
	      rulesetId: rulesetObj ? rulesetObj.id : null
	    };
	  });
	});

/***/ },

/***/ 3396:
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },

/***/ 3397:
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(3398),
	    isArray = __webpack_require__(3404),
	    isArrayLike = __webpack_require__(3399),
	    isFunction = __webpack_require__(3407),
	    isObjectLike = __webpack_require__(3403),
	    isString = __webpack_require__(3409),
	    keys = __webpack_require__(3410);
	
	/**
	 * Checks if `value` is empty. A value is considered empty unless it is an
	 * `arguments` object, array, string, or jQuery-like collection with a length
	 * greater than `0` or an object with own enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {Array|Object|string} value The value to inspect.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	      (isObjectLike(value) && isFunction(value.splice)))) {
	    return !value.length;
	  }
	  return !keys(value).length;
	}
	
	module.exports = isEmpty;


/***/ },

/***/ 3398:
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(3399),
	    isObjectLike = __webpack_require__(3403);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },

/***/ 3399:
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(3400),
	    isLength = __webpack_require__(3402);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },

/***/ 3400:
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(3401);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },

/***/ 3401:
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },

/***/ 3402:
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },

/***/ 3403:
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },

/***/ 3404:
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(3405),
	    isLength = __webpack_require__(3402),
	    isObjectLike = __webpack_require__(3403);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },

/***/ 3405:
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(3406);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },

/***/ 3406:
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(3407),
	    isObjectLike = __webpack_require__(3403);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },

/***/ 3407:
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3408);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },

/***/ 3408:
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },

/***/ 3409:
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(3403);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },

/***/ 3410:
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(3405),
	    isArrayLike = __webpack_require__(3399),
	    isObject = __webpack_require__(3408),
	    shimKeys = __webpack_require__(3411);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },

/***/ 3411:
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(3398),
	    isArray = __webpack_require__(3404),
	    isIndex = __webpack_require__(3412),
	    isLength = __webpack_require__(3402),
	    keysIn = __webpack_require__(3413);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },

/***/ 3412:
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },

/***/ 3413:
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(3398),
	    isArray = __webpack_require__(3404),
	    isIndex = __webpack_require__(3412),
	    isLength = __webpack_require__(3402),
	    isObject = __webpack_require__(3408);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },

/***/ 3414:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateResultDisplay = exports.sortColumn = undefined;
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getDateRange = getDateRange;
	exports.generateAggregateEventTriggerDisplayName = generateAggregateEventTriggerDisplayName;
	exports.generateAggregateEventDisplayName = generateAggregateEventDisplayName;
	exports.generateAggregateEventDisplayTime = generateAggregateEventDisplayTime;
	exports.generateEventEntityName = generateEventEntityName;
	exports.getARLinkForEvent = getARLinkForEvent;
	exports.generateEventStatus = generateEventStatus;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _moment = __webpack_require__(919);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isString = __webpack_require__(3409);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _antd = __webpack_require__(781);
	
	var _constants = __webpack_require__(3393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortColumn = exports.sortColumn = function sortColumn(key) {
	  return function (a, b) {
	    var sortA = a[key];
	    var sortB = b[key];
	    if ((0, _isString2.default)(sortA)) sortA = sortA.toLowerCase();
	    if ((0, _isString2.default)(sortB)) sortB = sortB.toLowerCase();
	    if (sortA < sortB) return -1;
	    if (sortA > sortB) return 1;
	    return 0;
	  };
	};
	
	function getDateRange(params) {
	  var dateFormat = 'YYYY-MM-DDTHH:mm:ss';
	  var formatUTC = function formatUTC(value) {
	    return value.utc().format(dateFormat);
	  };
	  var startTime = null;
	  var endTime = null;
	
	  switch (params && params.filterRange) {
	    case 'TODAY':
	      startTime = formatUTC((0, _moment2.default)().startOf('day'));
	      endTime = formatUTC((0, _moment2.default)().endOf('day'));
	      break;
	    case 'YESTERDAY':
	      startTime = formatUTC((0, _moment2.default)().startOf('day').subtract(1, 'days'));
	      endTime = formatUTC((0, _moment2.default)().endOf('day').subtract(1, 'days'));
	      break;
	    case 'LAST_N_DAYS':
	      startTime = formatUTC((0, _moment2.default)().startOf('day').subtract(params.lastNdays, 'days'));
	      endTime = formatUTC((0, _moment2.default)().endOf('day'));
	      break;
	    case 'THIS_MONTH':
	      startTime = formatUTC((0, _moment2.default)().startOf('month'));
	      endTime = formatUTC((0, _moment2.default)().endOf('month'));
	      break;
	    case 'LAST_MONTH':
	      startTime = formatUTC((0, _moment2.default)().subtract(1, 'months').startOf('month'));
	      endTime = formatUTC((0, _moment2.default)().subtract(1, 'months').endOf('month'));
	      break;
	    case 'DATE_RANGE':
	      startTime = formatUTC(params.startTime.startOf('day'));
	      endTime = formatUTC(params.endTime.endOf('day'));
	      break;
	    default:
	      // TODAY
	      startTime = formatUTC((0, _moment2.default)().startOf('day'));
	      endTime = formatUTC((0, _moment2.default)().endOf('day'));
	      break;
	  }
	  return { startTime: startTime, endTime: endTime };
	}
	
	function generateAggregateEventTriggerDisplayName(_ref) {
	  var origin = _ref.origin,
	      actor = _ref.actor;
	
	  switch (origin) {
	    case _constants.RIPPLE_FACEBOOK_PLATFORM:
	      return _constants.RULE_HIERARCHY.map(function (level) {
	        var entity = actor.find(function (entityLevel) {
	          return entityLevel.type === level;
	        });
	        return entity.name;
	      }).join(' > ');
	    case _constants.MONEYTALK_FACEBOOK_PLATFORM:
	      return 'Auto-Import';
	    case _constants.THUMBSUP_FACEBOOK_PLATFORM:
	      return 'User-Initiated Import';
	    default:
	      return 'Unknown Trigger';
	  }
	}
	
	function generateAggregateEventDisplayName(_ref2) {
	  var count = _ref2.count,
	      origin = _ref2.origin,
	      affectedEntity = _ref2.affectedEntity,
	      sampleResult = _ref2.sampleResult;
	
	  var affectedEntityTypes = affectedEntity.map(function (entity) {
	    return entity.type;
	  });
	  var lowestEntityLevel = _constants.ENTITY_LEVELS.find(function (entity) {
	    return affectedEntityTypes.includes(entity);
	  }) || "Campaign";
	  var plurality = count === 1 ? '' : 's';
	
	  if (origin === _constants.RIPPLE_FACEBOOK_PLATFORM && sampleResult) {
	    var actionDesc = sampleResult.find(function (res) {
	      return res.key === "actionDesc";
	    });
	    return actionDesc.value + ' for ' + count + ' ' + lowestEntityLevel + plurality;
	  } else if (origin === _constants.MONEYTALK_FACEBOOK_PLATFORM || origin === _constants.THUMBSUP_FACEBOOK_PLATFORM) {
	    return count + ' ' + lowestEntityLevel + plurality + ' Imported';
	  }
	
	  return count + ' ' + lowestEntityLevel + plurality + ' affected';
	}
	
	function generateAggregateEventDisplayTime(timestamp) {
	  var date = _moment2.default.utc(timestamp).local();
	  return date.format('MMM DD, YYYY - h:mma');
	}
	
	function generateEventEntityName(affectedEntity) {
	  var eventEntityNameList = [];
	  var firstEntity = true;
	
	  _constants.ENTITY_LEVELS.filter(function (entity) {
	    return entity !== 'Advertiser';
	  }).forEach(function (entity) {
	    var affected = affectedEntity.find(function (affectedE) {
	      return affectedE.type === entity;
	    });
	    if (affected) {
	      if (firstEntity) {
	        eventEntityNameList.push('<span style="font-weight: bold; display: block;">' + affected.name + ' (' + affected.id + ')</span>');
	        firstEntity = false;
	      } else {
	        eventEntityNameList.push('' + affected.name);
	      }
	    }
	  });
	  return eventEntityNameList[0] + ' ' + (eventEntityNameList.shift().length >= 1 ? eventEntityNameList.join(' > ') : '');
	}
	
	function getARLinkForEvent(sampleResult) {
	  var arReportUrl = sampleResult.find(function (res) {
	    return res.key === "arReportUrl";
	  });
	  return arReportUrl ? arReportUrl.value : null;
	}
	
	var generateResultDisplay = exports.generateResultDisplay = function generateResultDisplay(results) {
	  var status = results.find(function (result) {
	    return result.key === "status";
	  });
	  var statusReason = results.find(function (result) {
	    return result.key === "statusReason";
	  });
	  var actionDesc = results.find(function (result) {
	    return result.key === "actionDesc";
	  });
	  var NA_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Helpers.generateResultDisplay.NA.message', defaultMessage: 'N/A' });
	
	  return _react2.default.createElement(
	    _antd.Tooltip,
	    { placement: 'left', title: statusReason && statusReason.value || actionDesc && actionDesc.value || '' },
	    _constants.STATUS_LEVELS[status.value] && _constants.STATUS_LEVELS[status.value].displayValue || NA_MESSAGE
	  );
	};
	
	function generateEventStatus(results) {
	  var start = results.find(function (result) {
	    return result.key === "startState";
	  });
	  var end = results.find(function (result) {
	    return result.key === "endState";
	  });
	  var action = results.find(function (result) {
	    return result.key === "action";
	  });
	  var status = results.find(function (result) {
	    return result.key === "status";
	  });
	  var NA_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Helpers.N/A.message', defaultMessage: 'N/A' });
	
	  var parseStartAndEndDecimal = function parseStartAndEndDecimal(object) {
	    return object && object.value ? '$' + parseFloat(object.value).toFixed(2) : NA_MESSAGE;
	  };
	  var parseStartAndEndState = function parseStartAndEndState(object) {
	    if (!object || !object.value) return NA_MESSAGE;
	    var color = object.value === 'PAUSED' ? _constants.WARNING_COLOUR : _constants.SUCCESS_COLOUR;
	    return _react2.default.createElement(
	      'span',
	      { style: { textTransform: 'capitalize', color: color } },
	      object.value.toLowerCase()
	    );
	  };
	
	  var rawValues = {
	    start: start ? start.value : 'N/A',
	    end: end ? end.value : 'N/A',
	    result: status ? status.value : 'N/A'
	  };
	
	  switch (action.value) {
	    case 'CHANGE_STATE':
	      return (0, _extends3.default)({}, rawValues, {
	        startDisplay: parseStartAndEndState(start),
	        endDisplay: parseStartAndEndState(end),
	        resultDisplay: generateResultDisplay(results)
	      });
	    case 'CHANGE_BID':
	    case 'CHANGE_BUDGET':
	      return (0, _extends3.default)({}, rawValues, {
	        startDisplay: parseStartAndEndDecimal(start),
	        endDisplay: parseStartAndEndDecimal(end),
	        resultDisplay: generateResultDisplay(results)
	      });
	    case 'NOTIFY':
	      return (0, _extends3.default)({}, rawValues, {
	        startDisplay: NA_MESSAGE,
	        endDisplay: NA_MESSAGE,
	        resultDisplay: _constants.STATUS_LEVELS[status.value].displayValue
	      });
	    default:
	      return (0, _extends3.default)({}, rawValues, {
	        startDisplay: NA_MESSAGE,
	        endDisplay: NA_MESSAGE,
	        resultDisplay: NA_MESSAGE
	      });
	  }
	}

/***/ },

/***/ 3415:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FilterBar = __webpack_require__(3416);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _ActivityTableContainer = __webpack_require__(3418);
	
	var _ActivityTableContainer2 = _interopRequireDefault(_ActivityTableContainer);
	
	__webpack_require__(3425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Activity = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Activity, _Component);
	
	  function Activity() {
	    (0, _classCallCheck3.default)(this, Activity);
	    return (0, _possibleConstructorReturn3.default)(this, (Activity.__proto__ || (0, _getPrototypeOf2.default)(Activity)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Activity, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Activity__Component' },
	        _react2.default.createElement(_FilterBar2.default, {
	          filters: this.props.filters,
	          aggregateEventUpdateAvailable: this.props.aggregateEventUpdateAvailable,
	          createAction: this.props.createAction
	        }),
	        _react2.default.createElement(_ActivityTableContainer2.default, null)
	      );
	    }
	  }]);
	  return Activity;
	}(_react.Component), _class.propTypes = {
	  createAction: _propTypes2.default.func.isRequired,
	  filters: _propTypes2.default.shape({
	    searchTerm: _propTypes2.default.string,
	    filterRange: _propTypes2.default.string,
	    startTime: _propTypes2.default.object,
	    endTime: _propTypes2.default.object,
	    lastNdays: _propTypes2.default.number
	  }).isRequired,
	  aggregateEventUpdateAvailable: _propTypes2.default.bool.isRequired
	}, _temp);
	exports.default = Activity;

/***/ },

/***/ 3416:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _initialiseProps;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEmpty = __webpack_require__(3397);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _moment = __webpack_require__(919);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _antd = __webpack_require__(781);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _constants = __webpack_require__(3393);
	
	__webpack_require__(3417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Option = _antd.Select.Option;
	var RangePicker = _antd.DatePicker.RangePicker;
	var FilterBar = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(FilterBar, _Component);
	
	  function FilterBar(props) {
	    (0, _classCallCheck3.default)(this, FilterBar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FilterBar.__proto__ || (0, _getPrototypeOf2.default)(FilterBar)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var _props$filters = props.filters,
	        _props$filters$filter = _props$filters.filterRange,
	        filterRange = _props$filters$filter === undefined ? "TODAY" : _props$filters$filter,
	        _props$filters$startT = _props$filters.startTime,
	        startTime = _props$filters$startT === undefined ? null : _props$filters$startT,
	        _props$filters$endTim = _props$filters.endTime,
	        endTime = _props$filters$endTim === undefined ? null : _props$filters$endTim,
	        _props$filters$lastNd = _props$filters.lastNdays,
	        lastNdays = _props$filters$lastNd === undefined ? null : _props$filters$lastNd;
	
	
	    _this.state = {
	      searchTerm: "",
	      startTime: startTime,
	      endTime: endTime,
	      lastNdays: lastNdays,
	      filterDropdownSelected: filterRange,
	      disableApplyFilter: true,
	      showApplyFilter: false,
	      showRefresh: true
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(FilterBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filterDropdownSelected = this.state.filterDropdownSelected;
	      var filterRange = nextProps.filters.filterRange;
	
	
	      if (filterDropdownSelected !== filterRange) {
	        var _nextProps$filters = nextProps.filters,
	            startTime = _nextProps$filters.startTime,
	            endTime = _nextProps$filters.endTime,
	            lastNdays = _nextProps$filters.lastNdays;
	
	        this.setState({
	          startTime: startTime,
	          endTime: endTime,
	          lastNdays: lastNdays,
	          filterDropdownSelected: filterRange
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'FilterBar__Component' },
	        this.renderDataFilter()
	      );
	    }
	  }]);
	  return FilterBar;
	}(_react.Component), _class.propTypes = {
	  createAction: _propTypes2.default.func.isRequired,
	  filters: _propTypes2.default.shape({
	    searchTerm: _propTypes2.default.string,
	    filterRange: _propTypes2.default.string,
	    startTime: _propTypes2.default.object,
	    endTime: _propTypes2.default.object,
	    lastNdays: _propTypes2.default.number
	  }).isRequired,
	  aggregateEventUpdateAvailable: _propTypes2.default.bool.isRequired
	}, _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.submitFilter = function () {
	    var _state = _this2.state,
	        searchTerm = _state.searchTerm,
	        startTime = _state.startTime,
	        endTime = _state.endTime,
	        lastNdays = _state.lastNdays,
	        filterDropdownSelected = _state.filterDropdownSelected;
	
	    var params = {
	      searchTerm: searchTerm,
	      filterRange: filterDropdownSelected,
	      startTime: startTime,
	      endTime: endTime,
	      lastNdays: lastNdays,
	      paginationSize: _constants.AGGREGATE_EVENTS_PAGINATION_SIZE
	    };
	    _this2.props.createAction('fetchAggregateEvents', params);
	    _this2.setState({
	      showApplyFilter: false,
	      showRefresh: true
	    });
	  };
	
	  this.searchInputChange = function (e) {
	    var value = e.target.value;
	    var _state2 = _this2.state,
	        filterDropdownSelected = _state2.filterDropdownSelected,
	        lastNdays = _state2.lastNdays,
	        startTime = _state2.startTime,
	        endTime = _state2.endTime;
	
	    var disableApplyFilter = filterDropdownSelected === 'LAST_N_DAYS' ? lastNdays === null : filterDropdownSelected === 'DATE_RANGE' ? startTime === null && endTime === null : false;
	    _this2.setState({
	      searchTerm: value === "" ? null : value,
	      showApplyFilter: true,
	      showRefresh: false,
	      disableApplyFilter: disableApplyFilter
	    });
	  };
	
	  this.lastNDaysChange = function (value) {
	    var noValue = value === undefined || value === "";
	    _this2.setState({
	      lastNdays: noValue ? null : value,
	      disableApplyFilter: noValue,
	      showApplyFilter: true,
	      showRefresh: false,
	      startTime: null,
	      endTime: null
	    });
	  };
	
	  this.rangePickerChange = function (value) {
	    if (!(0, _isEmpty2.default)(value)) {
	      _this2.setState({
	        startTime: value[0],
	        endTime: value[1],
	        disableApplyFilter: false,
	        showApplyFilter: true,
	        showRefresh: false,
	        lastNdays: null
	      });
	    } else {
	      _this2.setState({
	        startTime: null,
	        endTime: null,
	        disableApplyFilter: true,
	        showApplyFilter: true,
	        showRefresh: false
	      });
	    }
	  };
	
	  this.filterDropdownChange = function (value) {
	    var isNewValue = _this2.state.filterDropdownSelected !== value;
	    var secondFilterValueRequiredList = ['LAST_N_DAYS', 'DATE_RANGE'];
	    var missingRequiredValue = secondFilterValueRequiredList.includes(value);
	    _this2.setState({
	      filterDropdownSelected: value,
	      showApplyFilter: isNewValue,
	      disableApplyFilter: missingRequiredValue,
	      showRefresh: !isNewValue
	    });
	  };
	
	  this.displayLastNDays = function () {
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-bar-item' },
	      _react2.default.createElement(
	        'div',
	        { className: 'filter-bar-item-label' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.enterNDays.label', defaultMessage: 'Enter Days (n)' })
	      ),
	      _react2.default.createElement(_antd.InputNumber, {
	        min: 1,
	        max: 90,
	        style: { width: '100px' },
	        onChange: function onChange(value) {
	          return _this2.lastNDaysChange(value);
	        }
	      })
	    );
	  };
	
	  this.displayRangePicker = function () {
	    var _state3 = _this2.state,
	        startTime = _state3.startTime,
	        endTime = _state3.endTime;
	
	    var maxDate = (0, _moment2.default)().local().startOf('day').subtract(90, 'days').valueOf();
	    var todaysDate = (0, _moment2.default)().local().startOf('day').add(1, 'days').valueOf();
	    var disabledDate = function disabledDate(evalDate) {
	      return evalDate && (evalDate.valueOf() <= maxDate || evalDate.valueOf() >= todaysDate);
	    };
	    return _react2.default.createElement(
	      'div',
	      { className: 'filter-bar-item' },
	      _react2.default.createElement(
	        'div',
	        { className: 'filter-bar-item-label' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.selectRange.label', defaultMessage: 'Select Range' })
	      ),
	      _react2.default.createElement(RangePicker, {
	        style: { width: '200px' },
	        format: 'MMM-DD-YY',
	        allowClear: true,
	        showTime: false,
	        disabledDate: disabledDate,
	        onChange: function onChange(value) {
	          return _this2.rangePickerChange(value);
	        },
	        value: [startTime, endTime]
	      })
	    );
	  };
	
	  this.renderDataFilter = function () {
	    var _state4 = _this2.state,
	        disableApplyFilter = _state4.disableApplyFilter,
	        filterDropdownSelected = _state4.filterDropdownSelected,
	        showRefresh = _state4.showRefresh,
	        showApplyFilter = _state4.showApplyFilter;
	    var aggregateEventUpdateAvailable = _this2.props.aggregateEventUpdateAvailable;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'filter-bar-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-bar-item-label' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.selectDateRange.label', defaultMessage: 'Select Filter Date' })
	        ),
	        _react2.default.createElement(
	          _antd.Select,
	          {
	            showSearch: false,
	            style: { width: '150px' },
	            defaultValue: filterDropdownSelected,
	            value: filterDropdownSelected,
	            onChange: function onChange(value) {
	              return _this2.filterDropdownChange(value);
	            }
	          },
	          _constants.DATA_RANGE.map(function (range) {
	            return _react2.default.createElement(
	              Option,
	              { key: range.value, value: range.value },
	              range.label
	            );
	          })
	        )
	      ),
	      filterDropdownSelected === "LAST_N_DAYS" && _this2.displayLastNDays(),
	      filterDropdownSelected === "DATE_RANGE" && _this2.displayRangePicker(),
	      _react2.default.createElement(
	        'div',
	        { className: 'filter-bar-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-bar-item-label' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.search.label', defaultMessage: 'Search' })
	        ),
	        _react2.default.createElement(_antd.Input, { onChange: function onChange(e) {
	            return _this2.searchInputChange(e);
	          }, placeholder: 'Enter search keywords', style: { width: '150px' } })
	      ),
	      showApplyFilter && _react2.default.createElement(
	        'div',
	        { className: 'filter-bar-item' },
	        _react2.default.createElement(
	          _antd.Button,
	          { disabled: disableApplyFilter, type: 'primary', onClick: _this2.submitFilter },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.applyFilter.label', defaultMessage: 'Apply Filter' })
	        )
	      ),
	      showRefresh && _react2.default.createElement(
	        'div',
	        { className: 'filter-bar-item' },
	        _react2.default.createElement(
	          _antd.Tooltip,
	          { visible: aggregateEventUpdateAvailable, placement: 'right', title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.autoUpdate.label', defaultMessage: 'New updates found. Please refresh to see latest activity.' }) },
	          _react2.default.createElement(
	            _antd.Badge,
	            { dot: aggregateEventUpdateAvailable },
	            _react2.default.createElement(
	              _antd.Button,
	              { onClick: _this2.submitFilter },
	              _react2.default.createElement(_antd.Icon, { type: 'reload' })
	            )
	          )
	        )
	      )
	    );
	  };
	}, _temp);
	exports.default = FilterBar;

/***/ },

/***/ 3417:
/***/ function(module, exports) {



/***/ },

/***/ 3418:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(3335);
	
	var _helpers = __webpack_require__(3378);
	
	var _ActivityTableParent = __webpack_require__(3419);
	
	var _ActivityTableParent2 = _interopRequireDefault(_ActivityTableParent);
	
	var _actions = __webpack_require__(3392);
	
	var _actions2 = __webpack_require__(3423);
	
	var _selectors = __webpack_require__(3424);
	
	var _selectors2 = __webpack_require__(3395);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loadingAggregateEvents: state.events.loadingAggregateEvents,
	    aggregateEvents: (0, _selectors2.parseAggregateEvents)(state),
	    events: (0, _selectors2.getEvents)(state),
	    rules: (0, _selectors.getRules)(state),
	    filter: (0, _selectors2.getFilter)(state),
	    ruleErrors: (0, _selectors.getruleErrors)(state)
	  };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    createAction: (0, _helpers.buildActionsCollection)({
	      fetchAggregateEvents: _actions.fetchAggregateEvents,
	      fetchEvents: _actions.fetchEvents,
	      fetchRule: _actions2.fetchRule
	    }, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ActivityTableParent2.default);

/***/ },

/***/ 3419:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /* eslint-disable react/no-danger */
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _isEmpty = __webpack_require__(3397);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactRouter = __webpack_require__(717);
	
	var _selectors = __webpack_require__(3395);
	
	var _ActivityTableChild = __webpack_require__(3420);
	
	var _ActivityTableChild2 = _interopRequireDefault(_ActivityTableChild);
	
	var _constants = __webpack_require__(3393);
	
	__webpack_require__(3422);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityTableParent = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ActivityTableParent, _Component);
	
	  function ActivityTableParent(props) {
	    (0, _classCallCheck3.default)(this, ActivityTableParent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ActivityTableParent.__proto__ || (0, _getPrototypeOf2.default)(ActivityTableParent)).call(this, props));
	
	    _this.activityTableChildOnExpand = function (record) {
	      var _this$props = _this.props,
	          events = _this$props.events,
	          filter = _this$props.filter;
	      var transactionId = record.transactionId;
	
	      if ((0, _isEmpty2.default)(events[transactionId])) {
	        _this.props.createAction('fetchEvents', { transactionId: transactionId, searchTerm: filter.searchTerm });
	      }
	    };
	
	    _this.viewActivityTableChild = function (record) {
	      var events = _this.props.events;
	      var transactionId = record.transactionId,
	          origin = record.origin;
	
	      var determineParsedEvents = function determineParsedEvents() {
	        switch (origin) {
	          case _constants.RIPPLE_FACEBOOK_PLATFORM:
	            return (0, _selectors.parseEvents)({ events: events[transactionId] });
	          case _constants.MONEYTALK_FACEBOOK_PLATFORM:
	          case _constants.THUMBSUP_FACEBOOK_PLATFORM:
	            return (0, _selectors.parseAutoImportEvents)({ events: events[transactionId] });
	          default:
	            return [];
	        }
	      };
	      return _react2.default.createElement(_ActivityTableChild2.default, {
	        events: determineParsedEvents(),
	        origin: origin
	      });
	    };
	
	    _this.showRuleDescription = function (aggregateEvent) {
	      var rules = _this.props.rules;
	      var ruleId = aggregateEvent.ruleId;
	
	      if ((0, _isEmpty2.default)(rules[ruleId])) {
	        _this.props.createAction('fetchRule', ruleId);
	      }
	      _this.setState({
	        ruleId: ruleId
	      });
	
	      _this.toggleDescriptionModal();
	    };
	
	    _this.toggleDescriptionModal = function () {
	      _this.setState({
	        descriptionModalVisible: !_this.state.descriptionModalVisible
	      });
	    };
	
	    _this.renderDescriptionModal = function () {
	      var ruleId = _this.state.ruleId;
	      var _this$props2 = _this.props,
	          rules = _this$props2.rules,
	          ruleErrors = _this$props2.ruleErrors;
	
	      if (ruleErrors.includes(ruleId) || rules[ruleId] && !rules[ruleId].description) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'empty-modal-text' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.ruleDescription.notAvailable.text', defaultMessage: 'Rule not found. It may have been deleted since this event occurred.' })
	        );
	      }
	      if (!rules[ruleId]) return _react2.default.createElement(
	        'div',
	        { className: 'modal-loading-spinner' },
	        _react2.default.createElement(_antd.Spin, null)
	      );
	      return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: rules[ruleId].description } });
	    };
	
	    _this.renderDescriptionModalButtons = function () {
	      var ruleId = _this.state.ruleId;
	      var rules = _this.props.rules;
	
	      var buttons = [_react2.default.createElement(
	        _antd.Button,
	        { key: 'close', size: 'large', type: 'primary', onClick: function onClick() {
	            return _this.toggleDescriptionModal();
	          } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.ruleDescription.close.button', defaultMessage: 'Close' })
	      )];
	      if (!rules[ruleId]) return buttons;
	      var _rules$ruleId = rules[ruleId],
	          rulesetId = _rules$ruleId.rulesetId,
	          id = _rules$ruleId.id;
	
	      buttons.unshift(_react2.default.createElement(
	        _antd.Button,
	        { key: 'goToRule', size: 'large' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/automation_engine/' + rulesetId + '/builder/' + id, onClick: function onClick() {
	              return _this.toggleDescriptionModal();
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.ruleDescription.goToRule.button', defaultMessage: 'Edit Rule' })
	        )
	      ));
	      return buttons;
	    };
	
	    _this.renderPaginationButton = function () {
	      var _this$props3 = _this.props,
	          aggregateEvents = _this$props3.aggregateEvents,
	          loadingAggregateEvents = _this$props3.loadingAggregateEvents,
	          filter = _this$props3.filter;
	
	      if ((0, _isEmpty2.default)(aggregateEvents) || filter.paginationSize > aggregateEvents.length && !loadingAggregateEvents) return null;
	      var onNext = function onNext() {
	        var params = (0, _extends3.default)({}, filter, {
	          paginationSize: filter.paginationSize + _constants.AGGREGATE_EVENTS_PAGINATION_SIZE
	        });
	        _this.props.createAction('fetchAggregateEvents', params);
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'pagination' },
	        _react2.default.createElement(
	          _antd.Button,
	          { type: 'primary', loading: loadingAggregateEvents, onClick: onNext },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.pagination.button.message', defaultMessage: 'Load More' })
	        )
	      );
	    };
	
	    _this.state = {
	      descriptionModalVisible: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ActivityTableParent, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var triggerTooltipMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.trigger.column.tooltip', defaultMessage: 'Rules may have been edited since events were logged' });
	      var columns = [{
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.aggregateEvent.column', defaultMessage: 'Event' }),
	        dataIndex: 'aggregateEvent',
	        key: 'aggregateEvent'
	      }, {
	        title: _react2.default.createElement(
	          _antd.Tooltip,
	          { title: triggerTooltipMessage, placement: 'right' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.trigger.column', defaultMessage: 'Trigger' }),
	          _react2.default.createElement(_antd.Icon, { className: 'tooltip-icon', type: 'info-circle-o' })
	        ),
	        dataIndex: 'trigger',
	        key: 'trigger',
	        render: function render(text, record) {
	          if (record.origin === _constants.RIPPLE_FACEBOOK_PLATFORM) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.showRuleDescription(record);
	                  } },
	                record.trigger
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'div',
	            null,
	            record.trigger
	          );
	        }
	      }, {
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.time.column', defaultMessage: 'Time' }),
	        dataIndex: 'timestamp',
	        key: 'timestamp',
	        width: 200
	      }, {
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.actions.column', defaultMessage: 'Actions' }),
	        dataIndex: "actions",
	        key: "actions",
	        width: 90,
	        className: "action-icons",
	        render: function render(text, record) {
	          var arReportUrl = record.arReportUrl;
	
	          var arIconType = "export";
	
	          if (arReportUrl) {
	            return _react2.default.createElement(
	              'a',
	              { href: arReportUrl },
	              _react2.default.createElement(
	                _antd.Tooltip,
	                { getPopupContainer: function getPopupContainer() {
	                    return document.getElementsByClassName('action-icons')[0];
	                  }, title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.actions.column.arLink', defaultMessage: 'View in AR' }) },
	                _react2.default.createElement(_antd.Icon, { type: arIconType })
	              )
	            );
	          }
	
	          return _react2.default.createElement(
	            _antd.Tooltip,
	            { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.actions.column.noARLink', defaultMessage: 'Link Not Available' }) },
	            _react2.default.createElement(
	              'span',
	              { className: 'disable-cursor' },
	              _react2.default.createElement(
	                'a',
	                { disabled: true },
	                _react2.default.createElement(_antd.Icon, { type: arIconType })
	              )
	            )
	          );
	        }
	      }];
	
	      var _props = this.props,
	          loadingAggregateEvents = _props.loadingAggregateEvents,
	          aggregateEvents = _props.aggregateEvents;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityTableParent__Component' },
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'key',
	          size: 'middle',
	          bordered: true,
	          loading: loadingAggregateEvents,
	          columns: columns,
	          dataSource: aggregateEvents,
	          expandedRowRender: function expandedRowRender(record) {
	            return _this2.viewActivityTableChild(record);
	          },
	          onExpand: function onExpand(expanded, record) {
	            return _this2.activityTableChildOnExpand(record);
	          },
	          pagination: false
	        }),
	        _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.ruleDescription.title', defaultMessage: 'Rule Description' }),
	            visible: this.state.descriptionModalVisible,
	            width: 800,
	            onCancel: function onCancel() {
	              return _this2.toggleDescriptionModal();
	            },
	            footer: this.renderDescriptionModalButtons()
	          },
	          this.renderDescriptionModal()
	        ),
	        this.renderPaginationButton()
	      );
	    }
	  }]);
	  return ActivityTableParent;
	}(_react.Component), _class.propTypes = {
	  createAction: _propTypes2.default.func.isRequired,
	  loadingAggregateEvents: _propTypes2.default.bool.isRequired,
	  aggregateEvents: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  rules: _propTypes2.default.objectOf(_propTypes2.default.object).isRequired,
	  ruleErrors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  events: _propTypes2.default.objectOf(_propTypes2.default.array).isRequired,
	  filter: _propTypes2.default.shape({
	    paginationSize: _propTypes2.default.number
	  }).isRequired
	}, _class.defaultProps = {
	  ruleErrors: []
	}, _temp);
	exports.default = ActivityTableParent;

/***/ },

/***/ 3420:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2; /* eslint-disable react/no-danger */
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _isEmpty = __webpack_require__(3397);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _helpers = __webpack_require__(3414);
	
	var _constants = __webpack_require__(3393);
	
	__webpack_require__(3421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityTableChild = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(ActivityTableChild, _Component);
	
	  function ActivityTableChild() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ActivityTableChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActivityTableChild.__proto__ || (0, _getPrototypeOf2.default)(ActivityTableChild)).call.apply(_ref, [this].concat(args))), _this), _this.determineColumn = function (origin) {
	      switch (origin) {
	        case _constants.RIPPLE_FACEBOOK_PLATFORM:
	          return ActivityTableChild.DEFAULT_COLUMNS;
	        case _constants.MONEYTALK_FACEBOOK_PLATFORM:
	        case _constants.THUMBSUP_FACEBOOK_PLATFORM:
	          return ActivityTableChild.IMPORT_COLUMNS;
	        default:
	          return [];
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ActivityTableChild, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          events = _props.events,
	          origin = _props.origin;
	
	      var columns = this.determineColumn(origin);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityTableChild__Component' },
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'id',
	          size: 'default',
	          columns: columns,
	          loading: (0, _isEmpty2.default)(events),
	          dataSource: events,
	          pagination: {
	            size: "small",
	            defaultPageSize: 15
	          }
	        })
	      );
	    }
	  }]);
	  return ActivityTableChild;
	}(_react.Component), _class.propTypes = {
	  events: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  origin: _propTypes2.default.string.isRequired
	}, _class.defaultProps = {
	  events: []
	}, _class.DEFAULT_COLUMNS = [{
	  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.entity.column', defaultMessage: 'Entity' }),
	  dataIndex: 'affectedEntity',
	  key: 'affectedEntity',
	  sorter: (0, _helpers.sortColumn)('affectedEntity'),
	  render: function render(affectedEntity) {
	    return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: affectedEntity } });
	  }
	}, {
	  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.start.column', defaultMessage: 'Start' }),
	  dataIndex: 'startDisplay',
	  key: 'start',
	  className: 'text-align-center',
	  width: '100px',
	  sorter: (0, _helpers.sortColumn)('start')
	}, {
	  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.end.column', defaultMessage: 'End' }),
	  dataIndex: 'endDisplay',
	  key: 'end',
	  className: 'text-align-center',
	  width: '100px',
	  sorter: (0, _helpers.sortColumn)('end')
	}, {
	  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.result.column', defaultMessage: 'Result' }),
	  dataIndex: 'resultDisplay',
	  key: 'result',
	  className: 'text-align-center',
	  width: '100px',
	  sorter: (0, _helpers.sortColumn)('result')
	}], _class.IMPORT_COLUMNS = [{
	  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.entity.column', defaultMessage: 'Entity' }),
	  dataIndex: 'affectedEntity',
	  key: 'affectedEntity',
	  sorter: (0, _helpers.sortColumn)('affectedEntity'),
	  render: function render(affectedEntity) {
	    return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: affectedEntity } });
	  }
	}, {
	  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.result.column', defaultMessage: 'Result' }),
	  dataIndex: 'resultDisplay',
	  key: 'result',
	  className: 'text-align-center',
	  width: '100px',
	  sorter: (0, _helpers.sortColumn)('result')
	}], _temp2);
	exports.default = ActivityTableChild;

/***/ },

/***/ 3421:
/***/ function(module, exports) {



/***/ },

/***/ 3422:
/***/ function(module, exports) {



/***/ },

/***/ 3423:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchRule = fetchRule;
	
	var _constants = __webpack_require__(3332);
	
	function fetchRule(ruleId) {
	  return {
	    type: _constants.FETCH_RULE,
	    payload: {
	      ruleId: ruleId
	    }
	  };
	}

/***/ },

/***/ 3424:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getRules = exports.getRules = function getRules(state) {
	  return state.rules.rulesData;
	};
	
	var getruleErrors = exports.getruleErrors = function getruleErrors(state) {
	  return state.rules.ruleErrors;
	};

/***/ },

/***/ 3425:
/***/ function(module, exports) {



/***/ },

/***/ 3426:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(779);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _effects = __webpack_require__(715);
	
	var _redux = __webpack_require__(3317);
	
	var _constants = __webpack_require__(3329);
	
	var _executors = __webpack_require__(3427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchEventsWatcher, fetchAggregateEventsWatcher].map(_regenerator2.default.mark);
	
	function fetchEventsWatcher() {
	  return _regenerator2.default.wrap(function fetchEventsWatcher$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_constants.FETCH_EVENTS, _executors.fetchEventsExecutor);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function fetchAggregateEventsWatcher() {
	  return _regenerator2.default.wrap(function fetchAggregateEventsWatcher$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants.FETCH_AGGREGATE_EVENTS, _redux.SESSION_CHANGE_ADVERTISER], _executors.fetchAggregateEventsExecutor);
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.takeLatest)([_constants.FETCH_AGGREGATE_EVENTS, _redux.SESSION_CHANGE_ADVERTISER], _executors.autofetchAggregateEventsExecutor);
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	var sagas = [fetchEventsWatcher, fetchAggregateEventsWatcher];
	
	exports.default = sagas;

/***/ },

/***/ 3427:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(779);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.fetchEventsExecutor = fetchEventsExecutor;
	exports.fetchAggregateEventsExecutor = fetchAggregateEventsExecutor;
	exports.autofetchAggregateEventsExecutor = autofetchAggregateEventsExecutor;
	
	var _axios = __webpack_require__(569);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _effects = __webpack_require__(715);
	
	var _reduxSaga = __webpack_require__(705);
	
	var _redux = __webpack_require__(3317);
	
	var _pick = __webpack_require__(3428);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _identity = __webpack_require__(3432);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _moment = __webpack_require__(919);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(3414);
	
	var _constants = __webpack_require__(3329);
	
	var _constants2 = __webpack_require__(3393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchEventsExecutor, fetchAggregateEventsExecutor, autofetchAggregateEventsExecutor].map(_regenerator2.default.mark);
	
	function fetchEventsExecutor(_ref) {
	  var payload = _ref.payload;
	  var transactionId, searchTerm, ENDPOINTS, advertiserId, filter, params, request;
	  return _regenerator2.default.wrap(function fetchEventsExecutor$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          transactionId = payload.transactionId, searchTerm = payload.searchTerm;
	          _context.next = 3;
	          return (0, _effects.select)(function (state) {
	            return state.session.ENDPOINTS;
	          });
	
	        case 3:
	          ENDPOINTS = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(function (state) {
	            return state.session.currentAdvertiser;
	          });
	
	        case 6:
	          advertiserId = _context.sent;
	          _context.next = 9;
	          return (0, _effects.select)(function (state) {
	            return state.events.filter;
	          });
	
	        case 9:
	          filter = _context.sent;
	          params = (0, _pick2.default)((0, _extends3.default)({
	            advertiserId: advertiserId,
	            searchTerm: searchTerm
	          }, (0, _helpers.getDateRange)(filter)), _identity2.default);
	          _context.prev = 11;
	          _context.next = 14;
	          return (0, _effects.call)(_axios2.default.get, ENDPOINTS.crossroads_api_url + '/events/' + transactionId, { params: params });
	
	        case 14:
	          request = _context.sent;
	          _context.next = 17;
	          return (0, _effects.put)({ type: _constants.FETCH_EVENTS_SUCCESS, payload: { transactionId: transactionId, data: request.data } });
	
	        case 17:
	          _context.next = 23;
	          break;
	
	        case 19:
	          _context.prev = 19;
	          _context.t0 = _context['catch'](11);
	          _context.next = 23;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context.t0 });
	
	        case 23:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[11, 19]]);
	}
	
	function fetchAggregateEventsExecutor(_ref2) {
	  var payload = _ref2.payload;
	  var filterParams, advertiserId, ENDPOINTS, params, request;
	  return _regenerator2.default.wrap(function fetchAggregateEventsExecutor$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          filterParams = payload.filterParams;
	          _context2.next = 3;
	          return (0, _effects.put)({ type: _constants.FETCH_AGGREGATE_EVENTS_LOADING, payload: true });
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.select)(function (state) {
	            return state.session.currentAdvertiser;
	          });
	
	        case 5:
	          advertiserId = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.select)(function (state) {
	            return state.session.ENDPOINTS;
	          });
	
	        case 8:
	          ENDPOINTS = _context2.sent;
	          params = (0, _pick2.default)((0, _extends3.default)({
	            advertiserId: advertiserId,
	            searchTerm: filterParams && filterParams.searchTerm,
	            size: filterParams && filterParams.paginationSize || _constants2.AGGREGATE_EVENTS_PAGINATION_SIZE
	          }, (0, _helpers.getDateRange)(filterParams)), _identity2.default);
	          _context2.prev = 10;
	          _context2.next = 13;
	          return (0, _effects.call)(_axios2.default.get, ENDPOINTS.crossroads_api_url + '/aggregate-events', { params: params });
	
	        case 13:
	          request = _context2.sent;
	          _context2.next = 16;
	          return (0, _effects.put)({ type: _constants.FETCH_AGGREGATE_EVENTS_SUCCESS, payload: request.data });
	
	        case 16:
	          _context2.next = 24;
	          break;
	
	        case 18:
	          _context2.prev = 18;
	          _context2.t0 = _context2['catch'](10);
	          _context2.next = 22;
	          return (0, _effects.put)({ type: _constants.FETCH_AGGREGATE_EVENTS_LOADING, payload: false });
	
	        case 22:
	          _context2.next = 24;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context2.t0 });
	
	        case 24:
	          _context2.next = 26;
	          return (0, _effects.put)({ type: _constants.FETCH_AGGREGATE_EVENTS_LOADING, payload: false });
	
	        case 26:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[10, 18]]);
	}
	
	function autofetchAggregateEventsExecutor() {
	  var dataRangePreventAutoRefreshList, advertiserId, locationPathname, filterParams, ENDPOINTS, currentAggregateEvent, params, request;
	  return _regenerator2.default.wrap(function autofetchAggregateEventsExecutor$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          dataRangePreventAutoRefreshList = ['YESTERDAY', 'LAST_MONTH'];
	
	        case 1:
	          if (false) {
	            _context3.next = 35;
	            break;
	          }
	
	          _context3.next = 4;
	          return (0, _reduxSaga.delay)(_constants2.AUTO_FETCH_AGGREGATE_EVENTS_DELAY_TIME);
	
	        case 4:
	          _context3.next = 6;
	          return (0, _effects.select)(function (state) {
	            return state.session.currentAdvertiser;
	          });
	
	        case 6:
	          advertiserId = _context3.sent;
	          _context3.next = 9;
	          return (0, _effects.select)(function (state) {
	            return state.location.pathname;
	          });
	
	        case 9:
	          locationPathname = _context3.sent;
	
	          if (!(locationPathname !== '/advertisers/' + advertiserId + '/activity')) {
	            _context3.next = 12;
	            break;
	          }
	
	          return _context3.abrupt('break', 35);
	
	        case 12:
	          _context3.next = 14;
	          return (0, _effects.select)(function (state) {
	            return state.events.filter;
	          });
	
	        case 14:
	          filterParams = _context3.sent;
	
	          if (!(filterParams.filterRange && dataRangePreventAutoRefreshList.includes(filterParams.filterRange))) {
	            _context3.next = 17;
	            break;
	          }
	
	          return _context3.abrupt('break', 35);
	
	        case 17:
	          if (!(filterParams.filterRange === "DATE_RANGE" && filterParams.endTime && !(0, _moment2.default)(filterParams.endTime).isSame((0, _moment2.default)(), "day"))) {
	            _context3.next = 19;
	            break;
	          }
	
	          return _context3.abrupt('break', 35);
	
	        case 19:
	          _context3.next = 21;
	          return (0, _effects.select)(function (state) {
	            return state.session.ENDPOINTS;
	          });
	
	        case 21:
	          ENDPOINTS = _context3.sent;
	          _context3.next = 24;
	          return (0, _effects.select)(function (state) {
	            return state.events.aggregateEvents;
	          });
	
	        case 24:
	          currentAggregateEvent = _context3.sent;
	          params = (0, _pick2.default)((0, _extends3.default)({
	            advertiserId: advertiserId,
	            searchTerm: filterParams && filterParams.searchTerm,
	            size: 1
	          }, (0, _helpers.getDateRange)(filterParams)), _identity2.default);
	          _context3.next = 28;
	          return (0, _effects.call)(_axios2.default.get, ENDPOINTS.crossroads_api_url + '/aggregate-events', { params: params });
	
	        case 28:
	          request = _context3.sent;
	
	          if (!(request.data.data[0] && request.data.data[0].transactionId !== currentAggregateEvent[0].transactionId)) {
	            _context3.next = 33;
	            break;
	          }
	
	          _context3.next = 32;
	          return (0, _effects.put)({ type: _constants.AUTO_FETCH_AGGREGATE_EVENTS });
	
	        case 32:
	          return _context3.abrupt('break', 35);
	
	        case 33:
	          _context3.next = 1;
	          break;
	
	        case 35:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },

/***/ 3428:
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(3429),
	    bindCallback = __webpack_require__(3431),
	    pickByArray = __webpack_require__(3433),
	    pickByCallback = __webpack_require__(3435),
	    restParam = __webpack_require__(3439);
	
	/**
	 * Creates an object composed of the picked `object` properties. Property
	 * names may be specified as individual arguments or as arrays of property
	 * names. If `predicate` is provided it is invoked for each property of `object`
	 * picking the properties `predicate` returns truthy for. The predicate is
	 * bound to `thisArg` and invoked with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to pick, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.pick(object, 'user');
	 * // => { 'user': 'fred' }
	 *
	 * _.pick(object, _.isString);
	 * // => { 'user': 'fred' }
	 */
	var pick = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  return typeof props[0] == 'function'
	    ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	    : pickByArray(object, baseFlatten(props));
	});
	
	module.exports = pick;


/***/ },

/***/ 3429:
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(3430),
	    isArguments = __webpack_require__(3398),
	    isArray = __webpack_require__(3404),
	    isArrayLike = __webpack_require__(3399),
	    isObjectLike = __webpack_require__(3403);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },

/***/ 3430:
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },

/***/ 3431:
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(3432);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },

/***/ 3432:
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },

/***/ 3433:
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(3434);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties specified
	 * by `props`.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);
	
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}
	
	module.exports = pickByArray;


/***/ },

/***/ 3434:
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3408);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },

/***/ 3435:
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(3436);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = pickByCallback;


/***/ },

/***/ 3436:
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(3437),
	    keysIn = __webpack_require__(3413);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },

/***/ 3437:
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(3438);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },

/***/ 3438:
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(3434);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },

/***/ 3439:
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },

/***/ 3440:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(779);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _effects = __webpack_require__(715);
	
	var _constants = __webpack_require__(3332);
	
	var _executors = __webpack_require__(3441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchRuleWatcher].map(_regenerator2.default.mark);
	
	function fetchRuleWatcher() {
	  return _regenerator2.default.wrap(function fetchRuleWatcher$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_constants.FETCH_RULE, _executors.fetchRuleExecutor);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	var sagas = [fetchRuleWatcher];
	
	exports.default = sagas;

/***/ },

/***/ 3441:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(779);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.fetchRuleExecutor = fetchRuleExecutor;
	
	var _axios = __webpack_require__(569);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _effects = __webpack_require__(715);
	
	var _redux = __webpack_require__(3317);
	
	var _constants = __webpack_require__(3332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchRuleExecutor].map(_regenerator2.default.mark);
	
	function fetchRuleExecutor(_ref) {
	  var payload = _ref.payload;
	  var ENDPOINTS, request;
	  return _regenerator2.default.wrap(function fetchRuleExecutor$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session.ENDPOINTS;
	          });
	
	        case 2:
	          ENDPOINTS = _context.sent;
	          _context.prev = 3;
	          _context.next = 6;
	          return (0, _effects.call)(_axios2.default.get, ENDPOINTS.ripple_api_url + '/rules/' + payload.ruleId);
	
	        case 6:
	          request = _context.sent;
	          _context.next = 9;
	          return (0, _effects.put)({ type: _constants.FETCH_RULE_SUCCESS, payload: request.data });
	
	        case 9:
	          _context.next = 17;
	          break;
	
	        case 11:
	          _context.prev = 11;
	          _context.t0 = _context['catch'](3);
	          _context.next = 15;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context.t0 });
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.put)({ type: _constants.FETCH_RULE_ERROR, payload: { id: payload.ruleId } });
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[3, 11]]);
	}

/***/ },

/***/ 3442:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(779);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _effects = __webpack_require__(715);
	
	var _constants = __webpack_require__(3391);
	
	var _executors = __webpack_require__(3443);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchCupidAndLoadWatcher].map(_regenerator2.default.mark);
	
	function fetchCupidAndLoadWatcher() {
	  return _regenerator2.default.wrap(function fetchCupidAndLoadWatcher$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_constants.FETCH_CUPID_AND_LOAD, _executors.fetchCupidAndLoadExecutor);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	var sagas = [fetchCupidAndLoadWatcher];
	
	exports.default = sagas;

/***/ },

/***/ 3443:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(779);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.fetchCupidAndLoadExecutor = fetchCupidAndLoadExecutor;
	
	var _moment = __webpack_require__(919);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _effects = __webpack_require__(715);
	
	var _redux = __webpack_require__(3317);
	
	var _constants = __webpack_require__(3329);
	
	var _constants2 = __webpack_require__(3393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchCupidAndLoadExecutor].map(_regenerator2.default.mark);
	
	function fetchCupidAndLoadExecutor(_ref) {
	  var payload = _ref.payload;
	  var cupidKey, successDeserializer;
	  return _regenerator2.default.wrap(function fetchCupidAndLoadExecutor$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          cupidKey = payload.cupidKey;
	
	          successDeserializer = function successDeserializer(data) {
	            var dataObj = JSON.parse(data.value);
	            var startTime = (0, _moment2.default)(dataObj.start_date);
	            var endTime = (0, _moment2.default)(dataObj.end_date);
	
	            return {
	              filterParams: {
	                filterRange: "DATE_RANGE",
	                paginationSize: _constants2.AGGREGATE_EVENTS_PAGINATION_SIZE,
	                startTime: startTime,
	                endTime: endTime
	              }
	            };
	          };
	
	          _context.next = 4;
	          return (0, _effects.put)({
	            type: _redux.CUPID_PAYLOAD_FETCH,
	            payload: {
	              cupidKey: cupidKey,
	              successAction: _constants.FETCH_AGGREGATE_EVENTS,
	              successDeserializer: successDeserializer
	            }
	          });
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ }

});


// WEBPACK FOOTER //
// 2.webpack_build.js